<template>
  <div class="ms-form ms-form--narrow">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomDate
            placeholder="Дата завершения"
            :value="this.formData.finish_date || ''"
            @change_date="(value) => onChange('finish_date', value)"
        />
        <CustomInput :value="this.formData.comment"
                     @change_input="(value) => this.onChange('comment', value)"
                     label="Комментарии" type="textarea" :required="true"/>
      </div>
      <CustomModalFooter :onCancel="this.closeModal" cancel-btn-text="Закрыть" :btn-loading="this.loading"/>
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomDate from "@/components/form/CustomDate";
import {setExecutiveReportDeadline} from "@/views/ExecutiveReport/services";
import CustomInput from "@/components/form/CustomInput";

export default {
  name: "executive-report-set-deadline",
  components: {CustomInput, CustomDate, CustomModalFooter},
  props: ['data', 'closeModal'],
  data() {
    return {
      loading: false,
      formData: {
        comment: '',
        finish_date: '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      const body = {
        ...this.data.body, ...this.formData
      }
      this.loading = true
      const res = await setExecutiveReportDeadline(body)
      this.loading = false
      if (!res) return
      this.rowsData = res
    },
  }
}
</script>
